import { XMLHttpRequest } from 'xmlhttprequest';
import * as Sentry from '@sentry/browser';

export const QLIK_CONFIG = {
  host: process.env.REACT_APP_QLIK_HOST,
  prefix: process.env.REACT_APP_QLIK_PREFIX,
  port: Number.parseInt(process.env.REACT_APP_QLIK_PORT),
  isSecure: !!process.env.REACT_APP_QLIK_IS_SECURE,
};

let qlik = null;
const apps = new Map();

function configureBaseURL() {
  try {
    window.require.config({
      baseUrl:
        `${(QLIK_CONFIG.isSecure ? 'https://' : 'http://')
        + QLIK_CONFIG.host
        + (QLIK_CONFIG.port ? `:${QLIK_CONFIG.port}` : '')
        + QLIK_CONFIG.prefix
        }resources`,
      config: {
        text: {
          useXhr: () => true,
          createXhr: () => {
            // use withCredentials flag to prevent authentication errors
            const xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            return xhr;
          },
        },
      },
    });
  } catch (error) {
    Sentry.captureException(error);
  }
}

export function initializeQlik() {
  configureBaseURL();

  return new Promise((resolve) => {
    window.require(['js/qlik'], (q) => {
      qlik = q;
      resolve(qlik);
    });
  });
}

export function getQlikApp(appId) {
  if (apps.has(appId)) {
    const app = apps.get(appId);
    return Promise.resolve(app);
  }

  const app = qlik.openApp(appId, QLIK_CONFIG);
  apps.set(appId, app);

  return Promise.resolve(app);
}

export function createHyperCubeDefForField(field) {
  return {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: [field],
        },
      },
    ],
    qInitialDataFetch: [
      {
        qTop: 0,
        qLeft: 0,
        qWidth: 1,
        qHeight: 10000,
      },
    ],
  };
}
